import { NAME } from './constants';

export const BULK_UPDATE_ITEMS = `${NAME}/BULK_UPDATE_ITEMS`;
export const BULK_UPDATE_ITEMS_FAILURE = `${NAME}/BULK_UPDATE_ITEMS_FAILURE`;
export const BULK_UPDATE_ITEMS_SUCCESS = `${NAME}/BULK_UPDATE_ITEMS_SUCCESS`;

export const FETCH_FILTER_ATTACHMENTS = `${NAME}/FETCH_FILTER_ATTACHMENTS`;
export const FETCH_FILTER_ATTACHMENTS_FAILURE = `${NAME}/FETCH_FILTER_ATTACHMENTS_FAILURE`;
export const FETCH_FILTER_ATTACHMENTS_SUCCESS = `${NAME}/FETCH_FILTER_ATTACHMENTS_SUCCESS`;

export const SAVE = `${NAME}/SAVE`;
export const SAVE_SUCCESS = `${NAME}/SAVE_SUCCESS`;
export const SAVE_FAILURE = `${NAME}/SAVE_FAILURE`;

export const SET_FILTER_DATA = `${NAME}/SET_FILTER_DATA`;
